import { useState, useCallback } from 'react';

export function useStepNavigation(totalSteps: number) {
  const [step, setStep] = useState(1);

  const goNext = useCallback(() => {
    setStep((s) => Math.min(s + 1, totalSteps));
  }, [totalSteps]);

  const goBack = useCallback(() => {
    setStep((s) => Math.max(s - 1, 1));
  }, []);

  const isFirstStep = step === 1;
  const isLastStep = step === totalSteps;
  const progress = (step / totalSteps) * 100;

  return { step, goNext, goBack, isFirstStep, isLastStep, progress, totalSteps };
}
